<mat-toolbar>
  <div class="left">
    @if (backButtonLink !== null) {
      <div class="back-button-container">
        <button mat-icon-button (click)="goBack()">
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
    } @else {
      <div class="spacer"></div>
    }
    <div class="rows">
      <div class="title-row">
        <div class="title">{{ title }}</div>
        @if (showAdminButton) {
          @if (currentUser$ | async; as user) {
            @if (user.role === 'SUPER') {
              <button mat-icon-button class="admin-button" (click)="navigateToAdminView()">
                <mat-icon fontSet="material-symbols-outlined">admin_panel_settings</mat-icon>
              </button>
            }
          }
        }
      </div>
      <ng-content select=".details"></ng-content>
    </div>
  </div>
  <div class="actions">
    <ng-content select=".actions"></ng-content>
  </div>
</mat-toolbar>
